var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.application)?_c(_vm.app_name,{tag:"component",attrs:{"application":_vm.application}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }